﻿export enum EmbroideryTapeType {
    Undefined = 0,
    Existing = 1,
    New = 2
}